import { Theme } from '@mui/material';
import config from '@shared/config';


const Button = (theme: Theme) => {
  return {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: config.theme.disableRipple,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: config.theme.elevation === 0,
      },
      styleOverrides: {
        root: {
          borderRadius: '10px',
          textTransform: 'none',
          position: 'relative',
        },
      },
      variants: [
        {
          props: { variant: 'outlined', color: 'primary' },
          style: {
            border: `2px solid ${theme.palette.primary.main}`,
            '&:hover': {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
            },
            '&.Mui-disabled': {
              borderColor: 'transparent',
            },
          },
        },
        {
          props: { variant: 'contained' },
          style: {
            '&.Mui-disabled': {
              backgroundColor: 'transparent',
            },
          },
        },
        {
          props: { color: 'primaryAlt' },
          style: {
            color: theme.palette.common.white,
          },
        },
      ],
    },
  };
};

export default Button;
